import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { TrustMarquee } from "@/components/landing/TrustMarquee";
import { Problem } from "@/components/landing/Problem";
import { DualAudience } from "@/components/landing/DualAudience";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Waitlist } from "@/components/landing/Waitlist";
import { ClosingCTA } from "@/components/landing/ClosingCTA";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  useLenis();
  return (
    <main className="bg-[#050914] min-h-screen" data-testid="landing-page">
      <Header />
      <Hero />
      <TrustMarquee />
      <Problem />
      <DualAudience />
      <HowItWorks />
      <Waitlist />
      <ClosingCTA />
      <Footer />
    </main>
  );
}
